module.exports = __webpack_public_path__ + "static/media/internalBooking.5c641920.png";